import React from 'react'
// eslint-disable-next-line import/named
import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon'
import { COLORS } from '../styles/variables'

export const IconAddPersonalGrowthTools: React.FC<SvgIconProps> = (props) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{
      color: COLORS.CERULEAN,
    }}
    {...props}
  >
    <path
        d="M18.9 14.17C16.52 14.17 14.6 16.09 14.6 18.47C14.6 20.85 16.52 22.77 18.9 22.77C21.28 22.77 23.2 20.85 23.2 18.47C23.2 16.09 21.28 14.17 18.9 14.17ZM18.9 21.63C17.14 21.63 15.74 20.18 15.74 18.47C15.74 16.76 17.19 15.31 18.9 15.31C20.61 15.31 22.06 16.76 22.06 18.47C22.06 20.18 20.66 21.63 18.9 21.63Z"
        stroke="none"
        fill="currentColor"
    />
    <path
        d="M20.4 17.9H19.42V16.92C19.42 16.66 19.21 16.4 18.9 16.4C18.59 16.4 18.38 16.61 18.38 16.92V17.9H17.4C17.14 17.9 16.88 18.11 16.88 18.42C16.88 18.73 17.09 18.94 17.4 18.94H18.38V19.92C18.38 20.18 18.59 20.44 18.9 20.44C19.21 20.44 19.42 20.23 19.42 19.92V18.94H20.4C20.66 18.94 20.92 18.73 20.92 18.42C20.92 18.11 20.71 17.9 20.4 17.9Z"
        stroke="none"
        fill="currentColor"
    />
    <path
        d="M18.68 8.86001C18.78 8.91001 18.89 8.91001 18.99 8.91001C19.15 8.91001 19.25 8.86001 19.35 8.81001C19.56 8.65001 19.71 8.45001 19.71 8.19001L19.76 3.73001C19.76 3.47001 19.6 3.21001 19.35 3.06001C19.14 2.96001 18.83 3.01001 18.62 3.16001L14.94 5.85001C14.73 6.01001 14.63 6.26001 14.63 6.52001C14.63 6.78001 14.79 6.99001 15.04 7.09001L16.02 7.56001L13.22 13.16L11.15 11.61C10.73 11.3 10.17 11.4 9.85 11.77L5.19 17.31L3.69 15.65C3.33 15.29 2.71 15.24 2.34 15.6C1.97 15.96 1.93 16.58 2.29 16.95L4.52 19.39C4.68 19.6 4.93 19.7 5.25 19.7C5.51 19.7 5.76999 19.54 5.97 19.34L10.74 13.69L13.02 15.35C13.23 15.51 13.54 15.56 13.8 15.51C14.06 15.46 14.32 15.25 14.42 14.99L17.74 8.36001L18.67 8.88001L18.68 8.86001Z"
        stroke="none"
        fill="currentColor"
    />
    <path
        d="M6.61999 8.79001C6.92999 8.79001 7.18999 8.53001 7.18999 8.22001C7.18999 7.91001 6.92999 7.65001 6.61999 7.65001C6.30999 7.65001 6.04999 7.91001 6.04999 8.22001C6.09999 8.53001 6.30999 8.79001 6.61999 8.79001Z"
        stroke="none"
        fill="currentColor"
    />
    <path
        d="M3.71999 8.79001C4.02999 8.79001 4.28999 8.53001 4.28999 8.22001C4.28999 7.91001 4.02999 7.65001 3.71999 7.65001C3.40999 7.65001 3.14999 7.91001 3.14999 8.22001C3.14999 8.53001 3.40999 8.79001 3.71999 8.79001Z"
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M9.57 8.79001C9.88 8.79001 10.14 8.53001 10.14 8.22001C10.14 7.91001 9.88 7.65001 9.57 7.65001C9.26 7.65001 9 7.91001 9 8.22001C9 8.53001 9.26 8.79001 9.57 8.79001Z" 
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M12.52 8.79001C12.83 8.79001 13.09 8.53001 13.09 8.22001C13.09 7.91001 12.83 7.65001 12.52 7.65001C12.21 7.65001 11.95 7.91001 11.95 8.22001C11.95 8.53001 12.21 8.79001 12.52 8.79001Z"
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M9.05 17.02C8.74 17.02 8.48 17.28 8.48 17.59C8.48 17.9 8.74 18.16 9.05 18.16C9.36 18.16 9.62 17.9 9.62 17.59C9.62 17.23 9.36 17.02 9.05 17.02Z" 
        stroke="none"
        fill="currentColor"
    />
    <path 
        d="M12.01 17.02C11.7 17.02 11.44 17.28 11.44 17.59C11.44 17.9 11.7 18.16 12.01 18.16C12.32 18.16 12.58 17.9 12.58 17.59C12.53 17.23 12.32 17.02 12.01 17.02Z" 
        stroke="none"
        fill="currentColor"
    />
  </SvgIcon>
)
